import { connect } from 'react-redux';
import { withTheme } from 'styled-components';

import Sorting from './Sorting';
import { trackFilterClickSortMatches } from '../../../../actions';

const mapDispatchToProps = {
    trackFilterClickSortMatches,
};

export default connect(undefined, mapDispatchToProps)(withTheme(Sorting));
